import { render, staticRenderFns } from "./TimelineItemsAdmin.vue?vue&type=template&id=063e929c&lang=pug&"
import script from "./TimelineItemsAdmin.vue?vue&type=script&lang=js&"
export * from "./TimelineItemsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports